import { getCurrentUser } from "../auth/auth.service";
import { staffApi } from "../api/staffApi";

/**
 * Options for a listing filter that picks organisation members (assignee,
 * responsible person, recovery owner…): the active members of the signed-in
 * organisation, searched by name, ten at a time. The option id is the member id.
 */
export async function fetchMemberFilterOptions(
  query: string,
  pageIndex: number,
): Promise<{ data: { id: string; label: string }[]; hasMore: boolean }> {
  try {
    const me = await getCurrentUser();
    const res = await staffApi.searchStaff({
      pageSize: 10,
      pageIndex,
      searchText: query,
      organisationIds: [`${me?.companyId}`],
      groupIds: [`${me?.companyId}`],
      isActive: true,
    });
    const rows = (res?.data ?? []) as {
      id: string;
      firstName?: string;
      lastName?: string;
    }[];
    const data = rows.map((s) => ({
      id: String(s.id),
      label: `${s.firstName ?? ""} ${s.lastName ?? ""}`.trim() || String(s.id),
    }));
    return { data, hasMore: data.length === 10 };
  } catch {
    return { data: [], hasMore: false };
  }
}
